import { message, List, Popconfirm, Tooltip, Input } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
} from "../../../../Components/Items";
import {
  PlusOutlined,
  EditOutlined,
  CheckCircleOutlined,
  StopOutlined,
  SaveOutlined,
} from "@ant-design/icons";

class NivelesEducativosModal extends Component {
  state = {
    loading: false,
    niveles: [],
    nuevoNombre: "",
    editandoId: null,
    nombreEdicion: "",
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      this.cargarNiveles();
    }
  }

  cargarNiveles = () => {
    this.setState({ loading: true });
    axios
      .post(
        "nivelesEducativos/selectNivelesEducativos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({
          loading: false,
          niveles: res.data.data || [],
        });
      })
      .catch(() => this.setState({ loading: false }));
  };

  agregar = () => {
    if (!this.state.nuevoNombre.trim()) {
      message.info("Ingresa un nombre");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "nivelesEducativos/agregarNivelEducativo",
        {
          empresaId: this.props.empresaId,
          nombre: this.state.nuevoNombre.trim(),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Nivel educativo agregado");
          this.setState({ nuevoNombre: "" });
          this.cargarNiveles();
        } else {
          this.setState({ loading: false });
          message.error("No se pudo agregar");
        }
      });
  };

  guardarEdicion = () => {
    if (!this.state.nombreEdicion.trim()) return;
    axios
      .post(
        "nivelesEducativos/editarNivelEducativo",
        {
          nivelEducativoId: this.state.editandoId,
          nombre: this.state.nombreEdicion.trim(),
        },
        { headers: this.props.headersToken }
      )
      .then(() => {
        this.setState({ editandoId: null, nombreEdicion: "" });
        this.cargarNiveles();
      });
  };

  cambiarEstado = (item) => {
    const url =
      item.estado === 1
        ? "nivelesEducativos/deshabilitarNivelEducativo"
        : "nivelesEducativos/habilitarNivelEducativo";
    axios
      .post(
        url,
        { nivelEducativoId: item._id },
        { headers: this.props.headersToken }
      )
      .then(() => this.cargarNiveles());
  };

  render() {
    const { editandoId, nombreEdicion, nuevoNombre, niveles } = this.state;

    return (
      <ModalItem
        title="Niveles Educativos"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.props.cerrarModal()}
        width={500}
      >
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <Input
            placeholder="Nombre del nivel educativo"
            value={nuevoNombre}
            onChange={(e) => this.setState({ nuevoNombre: e.target.value })}
            onPressEnter={this.agregar}
          />
          <ButtonItem
            type="primary"
            olivo
            className="botonAgregar"
            icon={<PlusOutlined />}
            onClick={this.agregar}
          >
            Agregar
          </ButtonItem>
        </div>
        <List
          size="small"
          bordered
          dataSource={niveles}
          renderItem={(item) => (
            <List.Item
              actions={[
                editandoId === item._id ? (
                  <Tooltip title="Guardar">
                    <ButtonItem
                      size="small"
                      lima
                      icon={<SaveOutlined />}
                      onClick={this.guardarEdicion}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title="Editar">
                    <ButtonItem
                      size="small"
                      cyan
                      icon={<EditOutlined />}
                      onClick={() =>
                        this.setState({
                          editandoId: item._id,
                          nombreEdicion: item.nombre,
                        })
                      }
                    />
                  </Tooltip>
                ),
                <Popconfirm
                  title={
                    item.estado === 1
                      ? "¿Deshabilitar este nivel?"
                      : "¿Habilitar este nivel?"
                  }
                  onConfirm={() => this.cambiarEstado(item)}
                  okText="Si"
                  cancelText="No"
                >
                  <ButtonItem
                    size="small"
                    lima={item.estado === 1}
                    rojo={item.estado !== 1}
                    icon={
                      item.estado === 1 ? (
                        <CheckCircleOutlined />
                      ) : (
                        <StopOutlined />
                      )
                    }
                  />
                </Popconfirm>,
              ]}
              style={{
                background: item.estado !== 1 ? "#fafafa" : undefined,
                opacity: item.estado !== 1 ? 0.7 : 1,
              }}
            >
              {editandoId === item._id ? (
                <Input
                  size="small"
                  value={nombreEdicion}
                  onChange={(e) =>
                    this.setState({ nombreEdicion: e.target.value })
                  }
                  onPressEnter={this.guardarEdicion}
                />
              ) : (
                item.nombre
              )}
            </List.Item>
          )}
          locale={{ emptyText: "Sin niveles educativos" }}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(NivelesEducativosModal);
